import { capitalizeWords } from '../../util';
import { FeesStatus, PaymentMethodEnum } from './TuitionFees/constant';
import { AddOnType, StudentPaymentData } from './types';

export const calculateTotalAmount = (fees: AddOnType[]): number => {
  return fees.reduce((total, item) => total + parseFloat(item.amount || '0'), 0);
};

export const printPaymentSummary = ({
  studentData,
  finalCostComponent,
  transactionNumber,
  selectedMethod,
  instituteData,
}: {
  studentData: StudentPaymentData;
  finalCostComponent: AddOnType[];
  transactionNumber: string;
  selectedMethod: string;
  instituteData: {
    logo?: string;
    name?: string;
    address?: string;
    email?: string;
    contact?: string;
    website?: string;
  };
}) => {
  const printWindow = window.open('', '_blank', 'width=800,height=600');
  if (!printWindow) {
    console.error('Failed to open print window.');
    return;
  }

  const paidMonths = studentData.feesDetails
    .filter((item) => item.feesStatus === FeesStatus.INPROCESS)
    .map((item) => item.month)
    .join(', ');

  const summaryHtml = finalCostComponent.map((item) => `<tr><td>${item.title}</td><td style="text-align:right;">₹${item.amount}</td></tr>`).join('');

  const paymentDate = `${new Date().toLocaleDateString()} ${new Date().toLocaleTimeString()}`;

  printWindow.document.write(`
    <html>
      <head>
        <title>Payment Summary</title>
        <style>
          * {
            box-sizing: border-box;
          }
          body {
            font-family: "Segoe UI", sans-serif;
            padding: 40px;
            color: #333;
            background-color: #fff;
          }
          .header {
            text-align: center;
            margin-bottom: 30px;
          }
          .logo {
            width: 80px;
            height: 80px;
            object-fit: cover;
            border-radius: 50%;
            margin-bottom: 10px;
          }
          .title {
            font-size: 24px;
            font-weight: bold;
            margin: 5px 0;
          }
          .sub-title {
            font-size: 14px;
            font-weight: 500;
            margin: 2px 0;
            color: #555;
          }
          .info-section {
            margin-bottom: 30px;
          }
          .info-grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 12px 20px;
            margin-top: 10px;
          }
          .label {
            font-weight: bold;
            font-size: 14px;
            color: #222;
          }
          .value {
            font-size: 14px;
            color: #444;
          }
          .summary-section {
            margin-top: 20px;
          }
          table {
            width: 100%;
            border-collapse: collapse;
            margin-top: 10px;
          }
          th, td {
            padding: 10px;
            border: 1px solid #ddd;
          }
          th {
            background-color: #f4f4f4;
            text-align: left;
          }
          tr:nth-child(even) {
            background-color: #f9f9f9;
          }
        </style>
      </head>
      <body>
        <div class="header">
          <img src="${instituteData.logo || '/images/dummyImage.png'}" alt="Logo" class="logo" />
          <div class="title">${capitalizeWords(instituteData.name || '')}</div>
          <div class="sub-title">${instituteData.address || ''}</div>
          <div class="sub-title">
            ${instituteData.email ? `Email: ${instituteData.email}` : ''}
            ${instituteData.contact ? ` | Contact: ${instituteData.contact}` : ''}
            ${instituteData.website ? ` | Website: ${instituteData.website}` : ''}
          </div>
        </div>

        <div class="info-section">
          <div class="label" style="margin-bottom: 8px;">Student & Payment Details</div>
          <div class="info-grid">
            <div><span class="label">Admission Id:</span> <span class="value">${studentData.admissionId}</span></div>
            <div><span class="label">Roll No.:</span> <span class="value">${studentData.classRollNo}</span></div>
            <div><span class="label">Name:</span> <span class="value">${studentData.name}</span></div>
            <div><span class="label">Class:</span> <span class="value">${studentData.class} ${studentData.section}</span></div>
            <div><span class="label">Email:</span> <span class="value">${studentData.email}</span></div>
            <div><span class="label">Contact No.:</span> <span class="value">${studentData.contactNo}</span></div>
            <div><span class="label">Mother's Name:</span> <span class="value">${studentData.motherName}</span></div>
            <div><span class="label">Father's Name:</span> <span class="value">${studentData.fatherName}</span></div>
            <div><span class="label">Payment Method:</span> <span class="value">${selectedMethod === PaymentMethodEnum.ONLINE ? 'Online' : 'Cash'}</span></div>
            ${
              selectedMethod === PaymentMethodEnum.ONLINE
                ? `<div><span class="label">Transaction Number:</span> <span class="value">${transactionNumber}</span></div>`
                : ''
            }
            <div><span class="label">Payment Date:</span> <span class="value">${paymentDate}</span></div>
            <div><span class="label">Fees Paid Month(s):</span> <span class="value">${paidMonths}</span></div>
          </div>
        </div>

        <div class="summary-section">
          <div class="label" style="margin-bottom: 8px;">Summary</div>
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th style="text-align:right;">Amount (₹)</th>
              </tr>
            </thead>
            <tbody>
              ${summaryHtml}
            </tbody>
          </table>
        </div>

        <script>
          window.onload = function() {
            window.print();
            setTimeout(() => { window.close(); }, 500);
          };
        </script>
      </body>
    </html>
  `);

  printWindow.document.close();
};
